import { useMutation } from "@tanstack/react-query";

import { env } from "@/config/env";
import authenticatedApi from "@/lib/api/client";

const BASE_URL = env.VITE_BASE_API_URL;

const downloadZipFile = async (fileIds: number[]) => {
  const queryParams = `fileIds=${fileIds.join(",")}`;

  const { token } = await authenticatedApi
    .url(`/attachments/download/bulk/files/token?${queryParams}`)
    .get()
    .json<{ token: string }>();

  const link = document.createElement("a");

  link.href = `${BASE_URL}/api/v1/attachments/download/bulk/from-token?token=${token}`;

  document.body.append(link);
  link.click();
  link.remove();
};

export function useDownloadBulkAttachments() {
  return useMutation({
    mutationFn: async (fileIds: number[]) => {
      await downloadZipFile(fileIds);
    },
  });
}
